import React, { type ReactNode } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { token } from '@atlaskit/tokens';
import {
	UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT,
	UNSAFE_DO_NOT_USE_BANNER_HEIGHT,
} from '@atlassian/jira-navigation-system/src/index.tsx';
import type { SidebarContainerProps } from '../../../types.tsx';

export const SidebarContainer = ({ children }: SidebarContainerProps) => (
	<SidebarWrapper>{children}</SidebarWrapper>
);

const getSidebarWidth = () => 360;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SidebarWrapper = styled.div<{
	children?: ReactNode;
}>({
	boxShadow: token('elevation.shadow.raised'),
	position: 'sticky',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	marginRight: `-${getSidebarWidth()}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	right: `-${getSidebarWidth()}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	top: `calc(${UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT} + ${UNSAFE_DO_NOT_USE_BANNER_HEIGHT})`,
	transition: 'right 300ms cubic-bezier(0.2, 0, 0, 1) 0s',
	/* This is needed so Fields stay on top of TopBarWrapper while dragging */
	zIndex: 12,
});
